import md5 from 'blueimp-md5/js/md5.min.js'

var app = {
    auth: false,
    accounts: [],
    permissions: {},
    config: {},
    mainCookie: ''
}

riot.observable(app)

app.checkUnsupported = () => {
    if (window.FormData === undefined) return true
    if (window.FileReader === undefined) return true
    if (typeof document.createElement("canvas").getContext !== 'function') return true
    return false
}

app.login = params => {
  $.ajax({
    url: './config.json',
    dataType: 'json',
    success(response) {
      if (response.status === 'ok') {
        var secookie = md5(String(Date.now()))
        API.url = `${response.data.hostApi}/api/`

        var project = params.project || response.data.project

        API.request({
          object: 'Auth',
          method: 'Info',
          data: {
            login: String(params.serial || '').trim(),
            hash: String(params.password || '').trim()
          },
          beforeSend(request) {
            request.setRequestHeader('Project', project)
            request.setRequestHeader('Secookie', secookie)
          },
          success(resp) {
            if (typeof params.success === 'function')
              params.success.call(this, resp, secookie)
          },
          error(resp) {
            if (typeof params.error === 'function')
              params.error.call(this, resp)
          }
        })
        return
      }

      if (response.status === 'error') {
        if (typeof params.error === 'function')
          params.error.call(this, response)
      }
    },
    error(response) {
      if (typeof params.error === 'function')
        params.error.call(this, response)
    }
  })
}

const accountFetchRetryDelays = [250, 700, 1500]

function fetchAccounts(params) {
  params = params || {}

  let attempt = params.attempt || 0
  let cookie = params.cookie
  let done = params.done || function () {}

  API.request({
    object: 'Account',
    method: 'Fetch',
    cookie: cookie,
    unauthorizedReload: false,
    success(resp) {
      app.mainCookie = cookie || localStorage.getItem('shop24_cookie')
      if (resp && Array.isArray(resp.items)) app.accounts = resp.items
    },
    complete(response, xhr) {
      if (xhr && xhr.status === 401 && attempt < accountFetchRetryDelays.length) {
        setTimeout(() => {
          fetchAccounts({
            cookie: cookie,
            done: done,
            attempt: attempt + 1
          })
        }, accountFetchRetryDelays[attempt])
        return
      }

      done(response, xhr)
    }
  })
}

app.init = () => {
    let res = localStorage.getItem('shop24')
    if (!res || res === 'undefined') res = '{}'

    let storage
    try { storage = JSON.parse(res) } catch(e) { storage = {} }

    if (storage && storage.domain) {
        app.config.project = storage.project
        app.config.version = storage.version
        app.config.lang = 'rus'
        app.config.projectURL = `${storage.domain}/`
        app.config.isAdmin = storage.isAdmin || false
        app.config.idUser = storage.idUser || 0
        app.auth = true
    } else {
        app.auth = false
    }

    if (!app.auth) {
        observable.trigger('auth', app.auth)
        return
    }

    // ✅ сброс
    app.permissions = {}

    let permissionsRaw = localStorage.getItem('shop24_permissions') || '[]'
    let permissions
    try { permissions = JSON.parse(permissionsRaw) } catch(e) { permissions = [] }

    if (Array.isArray(permissions)) {
        permissions.forEach(item => {
        if (item && item.code != null) app.permissions[item.code] = item.mask
        })
    }

    let mainUser
    let config

    try { mainUser = JSON.parse(localStorage.getItem('shop24_main_user') || '{}') } catch(e) { mainUser = {} }
    try { config = JSON.parse(localStorage.getItem('shop24') || '{}') } catch(e) { config = {} }

  if (config && mainUser &&
      'login' in config &&
      'login' in mainUser &&
      config.login !== mainUser.login) {

    app.login({
      project: mainUser.project,
      serial: mainUser.login,
      password: mainUser.hash,
      success(response, secookie) {
        fetchAccounts({
          cookie: secookie,
          done() {
            observable.trigger('auth', app.auth)
          }
        })
      },
      error() {
        observable.trigger('auth', app.auth)
      }
    })
  } else {
    fetchAccounts({
      done() {
        observable.trigger('auth', app.auth)
      }
    })
  }
}

app.restoreSession = user => {
  let params = JSON.parse(user)
  let secookie = md5(String(Date.now()))
  API.url = `${params.uri}/api/`

  API.request({
    object: 'Auth',
    method: 'Info',
    unauthorizedReload: false,
    data: params,
    beforeSend(request) {
      request.setRequestHeader('Secookie', secookie)
      request.setRequestHeader('Project', params.project)
    },
    success(response) {
      if (response.permissions) {
        const permStr = (typeof response.permissions === 'string')
          ? response.permissions
          : JSON.stringify(response.permissions)

        localStorage.setItem('shop24_permissions', permStr)

        // ✅ сразу строим мапу
        app.permissions = {}
        let arr
        try { arr = JSON.parse(permStr) } catch(e) { arr = [] }
        if (Array.isArray(arr)) {
          arr.forEach(item => {
            if (item && item.code != null) app.permissions[item.code] = item.mask
          })
        }
      }

      localStorage.setItem('shop24_cookie', secookie)
      localStorage.setItem('shop24', JSON.stringify(response.config))

      app.init()
      riot.route.start(true)
    },
    error() {
        localStorage.removeItem('shop24')
        localStorage.removeItem('shop24_permissions')
        localStorage.removeItem('shop24_cookie')
        localStorage.removeItem('shop24_user')
        localStorage.removeItem('shop24_main_user')

        app.auth = false
        observable.trigger('auth', false)
    }
  })
}

app.getImageUrl = function (name, section, lang = 'rus') {
    return `${app.config.projectURL}images/${lang}/${section}/${name}`
}

app.getImagePreviewURL = function (name, section, size = 64, lang = 'rus') {
    return `${app.config.projectURL}lib/image.php?size=${size}&img=images/${lang}/${section}/${name}`
}

app.insertText = function () {
    this.target = null

    this.focus = function (e) {
        this.target = e.target
    }

    this.insert = function (e) {
        if (this.target) {
            var value = this.target.value
            var start = this.target.selectionStart
            var end = this.target.selectionEnd
            var newstr = value.substr(0, start) + e.target.innerHTML + value.substr(end)
            this.target.value = newstr
            this.target.selectionEnd = this.target.selectionStart = start + e.target.innerHTML.length
            this.target.focus()
            var event = document.createEvent('Event')
            event.initEvent('change', true, true)
            this.target.dispatchEvent(event)
        }
    }

    return this
}

if (process.env.NODE_ENV === 'development')
    window.app = app

module.exports = app


// WEBPACK FOOTER //
// ./app.js